var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramSecurity40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 17 0 17 16.9583333 8.5 22 0 16.9583333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 8 0 8 10 0 10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(11.500000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.36111111 -2.29166667 19.3611111 -2.29166667 19.3611111 24.2916667 -2.36111111 24.2916667"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-4",
    stroke: "#4F4C4D",
    points: "0 0 17 0 17 16.9583333 8.5 22 0 16.9583333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFCC00",
    mask: "url(#mask-4)",
    points: "-2.22222222 -2.27272727 10.2222222 -2.27272727 10.2222222 12.2727273 -2.22222222 12.2727273"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(1.000000, 0.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-8",
    points: "7.52989755 0 16 0 16 9.82978723 7.52989755 9.82978723"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.52989755,
    y1: 0.893617021,
    x2: 7.52989755,
    y2: 21,
    id: "Stroke-9",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.0588775,
    y1: 9.82978723,
    x2: 0,
    y2: 9.82978723,
    id: "Stroke-10",
    strokeLinecap: "square"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramSecurity40);
export default __webpack_public_path__ + "static/media/pictogramSecurity40.ad8e140a630bed393082b8549d455b45.svg";
export { ForwardRef as ReactComponent };